export default __webpack_public_path__ + "static/media/sketch.1d17fe5e.svg";